export function easyScroll() {
  const targetEls = document.querySelectorAll("[data-easy-scroll]")

  if (!targetEls.length) return

  targetEls.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault()
      const value = el.getAttribute("data-easy-scroll")

      if (!value) {
        window.scrollTo({ top: 0, behavior: "auto" })
      } else if (!isNaN(Number(value))) {
        window.scrollTo({ top: Number(value), behavior: "auto" })
      } else {
        const targetEl = document.querySelector(value)

        if (targetEl) {
          const topPos = targetEl.getBoundingClientRect().top + window.scrollY
          window.scrollTo({ top: topPos, behavior: "auto" })
        }
      }
    })
  })
}
